import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { InPlaceEditor } from '@syncfusion/ej2-inplace-editor';

import { PayrollFrequency } from '@/shared/types/enum';

import { getControl, getEditor, getProps, updateEditor } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="payrollFrequency"]')]
    .map((editableElement) => editableElement as HTMLDivElement)
    .forEach((editableElement) => {
      const form = editableElement.closest('form') as HTMLFormElement;

      const dropDownList = getControl(editableElement.id) as DropDownList | undefined;

      const editor = getEditor(editableElement.id) as InPlaceEditor | undefined;

      const control = dropDownList ?? editor;

      if (control) {
        const refresh = (payrollFrequency: PayrollFrequency, options?: { save?: boolean }) => {
          const { save } = options ?? {};

          const selected = control.value === payrollFrequency;

          const dayTr = form.querySelector(`tr[data-payroll-frequency="${payrollFrequency}"]`) as HTMLTableRowElement;

          dayTr.classList.toggle('d-none', !selected);

          const dayEditable = dayTr.querySelector('.editable[data-field="payrollDay"]');

          if (dayEditable) {
            const dayEditableProps = getProps(dayEditable.id);

            const dayDropDownList = getControl(dayEditable.id) as DropDownList | undefined;

            const dayEditor = getEditor(dayEditable.id) as InPlaceEditor | undefined;

            const disabled = !selected || !!dayEditableProps?.readOnly;

            if (dayDropDownList) {
              dayDropDownList.enabled = !disabled;
            } else if (dayEditor) {
              dayEditor.disabled = disabled;

              if (selected && save) {
                updateEditor(dayEditable.id, null);
              }
            }
          }
        };

        refresh(PayrollFrequency.Weekly);
        refresh(PayrollFrequency.Fortnightly);
        refresh(PayrollFrequency.Monthly);
        refresh(PayrollFrequency.Quarterly);

        if (dropDownList) {
          dropDownList.addEventListener('change', () => {
            refresh(PayrollFrequency.Weekly);
            refresh(PayrollFrequency.Fortnightly);
            refresh(PayrollFrequency.Monthly);
            refresh(PayrollFrequency.Quarterly);
          });
        } else if (editor) {
          editor.addEventListener('actionSuccess', () => {
            refresh(PayrollFrequency.Weekly, { save: true });
            refresh(PayrollFrequency.Fortnightly, { save: true });
            refresh(PayrollFrequency.Monthly, { save: true });
            refresh(PayrollFrequency.Quarterly, { save: true });
          });
        }
      }
    });
});
